import { IS_NEWUSERS_OF_COMPANY_INVITED, SET_COMPANY_DETAILS, SET_ORGANISATION_FEATURES, SET_ORGANIZATION_DESCRIPTION, UPDATECOMPANY_STATUS, UPDATE_ORGANIZATION } from "../actions/action-types";

const initialState = {
  userReqBody: {},
  confirmCompany: false,
  organization: {},
  isNewUsersInvited: false,
  organizationDescription: {},
  organizationFeatureStatus: [],
};

/**
 * setting states according to the type of actions
 * @param {*} state
 * @param {*} action
 * @returns {state}
 */

const companyDetails = (state = initialState, action) => {
  switch (action.type) {
    case SET_COMPANY_DETAILS:
      return {
        userReqBody: action.company,
        confirmCompany: true,
      };
    case UPDATECOMPANY_STATUS:
      return {
        confirmCompany: action.status,
      };
    case UPDATE_ORGANIZATION:
      return {
        ...state,
        organization: action.payload,
      };
    case IS_NEWUSERS_OF_COMPANY_INVITED:
      return {
        ...state,
        isNewUsersInvited: true,
      };
    case SET_ORGANIZATION_DESCRIPTION:
      return {
        ...state,
        organizationDescription: action.payload,
      };
    case SET_ORGANISATION_FEATURES:
      return {
        ...state,
        organizationFeatureStatus: action.payload,
      };
    default:
      return state;
  }
};

export default companyDetails;
